module.exports = __webpack_public_path__ + "static/img/Dayne_Zorko_desktop.c2098e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dayne_Zorko_desktop.jpg
// module id = Wmbu
// module chunks = 0